import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getAbout } from '../../api/api';
import { useLocation, useNavigate } from 'react-router-dom';

const About = () => {
  const navigate = useNavigate();
  const location = useLocation();
    const data = useSelector(state => state.about.about);
    useEffect(() => {
      !data.club && getAbout();
    }, [])
  return data.about && (
    <div className='pb-5'>
              <div className='row about px-2'>
                    {/* <div className='col-12 container'>
                        <img src={data.img} width={'100%'} height={'300px'} 
                        style={{ 
                              borderRadius: '10%'
                         }}
                        />
                        <p> <small className='text-muted text-center'><b>({data.image_title})</b> </small> </p>
                    </div> */}
                    <div className='col-12 container'>
                    <p className='small-header m-0'>{data.club} </p>
                    <small className='text-muted m-0'>({data.moto}) </small>
                    <p>
                      {data.about.slice(0, 1000)}...
                    </p>
                    </div>
              </div>
              <span className='col d-flex align-items-center justify-content-end'>
            { location.pathname != '/about' &&
              <button
              onClick={()=> navigate('/about')}
              className='btn btn-color btn-lg d-flex justify-content-center align-items-center'
              style={{ fontWeight: 700, fontSize: 12, width: '130px' }}
              // variant='primary'
              >
                Read More
              </button>
            }
        </span>
        </div>
  )
}

export default About